<template>
  <v-app>
    <Auth />
    <v-navigation-drawer
      v-if="isLoggedIn"
      v-model="drawer"
      app
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title primary--text text-center">
            <v-img src="./assets/logo.png" contain :height="32" alt="logo" class="mb-5" />
          </v-list-item-title>
          <v-list-item-subtitle>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />
      <MenuDrawer />
      <v-divider />
      <AdminMenuDrawer v-if="isAdmin" />
      <v-spacer></v-spacer>
    </v-navigation-drawer>

    <v-app-bar app dark>
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="isLoggedIn" />
      <v-toolbar-title class="hidden-sm-and-down">
        <v-btn text color="primary" :to="{ name: 'AuthHome' }">
          <v-icon color="primary">{{ mdiHome }}</v-icon>
          Aqunion
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        class="mr-2"
        v-for="(menuItem, index) in topMenuItems" :key="`topMenuItem-${index}`"
        :to="{ name: menuItem.pathName }"
      >
        <v-icon color="primary">{{ menuItem.icon }}</v-icon>
        {{ $t(menuItem.name) }}
      </v-btn>
      <v-spacer></v-spacer>
      <Feedback />
      <div class="ml-2 hidden-sm-and-down">
        <Account />
      </div>
    </v-app-bar>
    <v-main>
      <keep-alive :include="[
        'AuthHome',
      ]">
        <router-view></router-view>
      </keep-alive>
    </v-main>
    <v-footer padless>
      <v-col
        class="text-center"
        cols="12"
      >
        Copyright &copy; {{ new Date().getFullYear() }} <strong>Aqunion</strong>
        <v-spacer></v-spacer>
        <Version style="color: black; position: relative; left: 0" />
      </v-col>
    </v-footer>

    <Toasts :text="message" color="success" />
    <Toasts :text="error" color="danger" />
    <BasicToasts />
  </v-app>
</template>

<script>
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { components as auroraAppCore } from '@codehq/aurora-app-core/src';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { mdiHome } from '@mdi/js';
import AppUpdateOverlay from './components/AppUpdateOverlay.vue';
import MenuDrawer from './components/MenuDrawer.vue';
import AdminMenuDrawer from './components/AdminMenuDrawer.vue';
import Feedback from './components/Feedback.vue';
import menuItems from './menuItems';
// import OrganizationSelect from './components/OrganizationSelect.vue';

const {
  Account, Auth, BasicToasts, LocaleSwitcher, Toasts, Version,
} = auroraAppCore;

export default {
  name: 'App',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AppUpdateOverlay,
    Account,
    Auth,
    AdminMenuDrawer,
    BasicToasts,
    // eslint-disable-next-line vue/no-unused-components
    LocaleSwitcher,
    MenuDrawer,
    // OrganizationSelect,
    Feedback,
    Toasts,
    Version,
  },
  mixins: [menuItems],
  data() {
    return {
      message: '',
      error: '',
      drawer: false,
      mdiHome,
    };
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isInRole']),
    isAdmin() {
      return this.isInRole('Administrators');
    },
    topMenuItems() {
      return this.menuItems.filter((m) => m.topMenu === true);
    },
  },
  created() {
    this.$root.$on('auth:login', () => {
      this.$router.push({ name: 'AuthHome' });
      this.$root.$emit('toast:notify', 'Logged in successfully');
      this.$log.info('login');
    });
    this.$root.$on('auth:logoff', () => {
      this.$router.push({ name: 'auth-Login' });
    });
    this.$root.$on('organizations.loaded', (organizations) => {
      if (organizations.length === 0 && this.isLoggedIn) {
        this.$router.push({
          name: 'auth-CreateOrg',
        });
      }
    });
    this.$root.$on('organization.saved', (organization) => {
      this.SET_organization(organization);
      this.$router.push({
        name: 'rental-properties-EditRentalProperty',
        params: {
          initial: true,
        },
      });
    });
    const instrumentationKey = process.env.VUE_APP_INSIGHTS_KEY;
    if (instrumentationKey?.length > 0) {
      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey,
        },
      });
      appInsights.loadAppInsights();
      appInsights.trackPageView();
    }
  },
  destroyed() {
    this.$root.$off('auth:login');
    this.$root.$off('auth:logoff');
  },
  methods: {
    ...mapActions('app', ['LOGOUT']),
    ...mapMutations('organizations', ['SET_organization']),
  },
};
</script>
<style>
main > div {
  padding: 20px;
}
.highlight-row {
  background-color: #00ffff;
}
</style>
